export default {
    props: {
        model: null,
    },
    computed: {
        timeFrames() {
            let timeFrames = []
            let interval, last, weekday, timeFrame
            this.$moment.locale(this.$store.getters['locale'])
            this.model.days.map((day, index) => {
                interval = day.time_intervals
                    .map((interval) =>
                        interval.open === interval.close
                            ? `${interval.open}`
                            : `${interval.open}-${interval.close}`
                    )
                    .join(', ')
                last = timeFrames.length - 1
                if (
                    index > 0 &&
                    interval === timeFrames[last].time &&
                    day.day - 1 === this.model.days[index - 1].day
                ) {
                    weekday = this.$moment().isoWeekday(day.day).format('ddd')
                    timeFrame = timeFrames[last].days.split('-')

                    if (timeFrame.length > 1) timeFrame[1] = weekday
                    else timeFrame.push(weekday)

                    timeFrames[last].days = timeFrame.join('-')
                } else {
                    timeFrames.push({
                        days: this.$moment().isoWeekday(day.day).format('ddd'),
                        time: interval,
                    })
                }
            })
            return timeFrames
        },
    },
}
